import { render, staticRenderFns } from "./TS13.vue?vue&type=template&id=0c60aee6&scoped=true&"
import script from "./TS13.vue?vue&type=script&lang=js&"
export * from "./TS13.vue?vue&type=script&lang=js&"
import style0 from "./TS13.vue?vue&type=style&index=0&id=0c60aee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60aee6",
  null
  
)

export default component.exports